import React from "react";

import type { Props as BoxProps } from "@busbud/design-system-components/dist/Box";
import BusLG from "@busbud/design-system-components/dist/Icons/Bus/LG";
import BusMD from "@busbud/design-system-components/dist/Icons/Bus/MD";
import CarLG from "@busbud/design-system-components/dist/Icons/Car/LG";
import CarMD from "@busbud/design-system-components/dist/Icons/Car/MD";
import FerryLG from "@busbud/design-system-components/dist/Icons/Ferry/LG";
import FerryMD from "@busbud/design-system-components/dist/Icons/Ferry/MD";
import ShuttleLG from "@busbud/design-system-components/dist/Icons/Shuttle/LG";
import ShuttleMD from "@busbud/design-system-components/dist/Icons/Shuttle/MD";
import TrainLG from "@busbud/design-system-components/dist/Icons/Train/LG";
import TrainMD from "@busbud/design-system-components/dist/Icons/Train/MD";
import type { IconComponentType } from "@busbud/design-system-components/dist/utilities/createSvgIcon";
import { VehicleType } from "@busbud/int-schemas/lib/vehicles";

type Size = "MD" | "LG";

interface Props extends BoxProps {
  type: VehicleType;
  size: Size;
}

const icon_map: Record<Size, Record<VehicleType, IconComponentType>> = {
  LG: {
    [VehicleType.Carpool]: CarLG,
    [VehicleType.Train]: TrainLG,
    [VehicleType.Van]: ShuttleLG,
    [VehicleType.Shuttle]: ShuttleLG,
    [VehicleType.Ferry]: FerryLG,
    [VehicleType.Bus]: BusLG
  },
  MD: {
    [VehicleType.Carpool]: CarMD,
    [VehicleType.Train]: TrainMD,
    [VehicleType.Van]: ShuttleMD,
    [VehicleType.Shuttle]: ShuttleMD,
    [VehicleType.Ferry]: FerryMD,
    [VehicleType.Bus]: BusMD
  }
};

export const VehicleIcon: React.FC<Props> = ({ type, size, ...other }) => {
  const Icon: IconComponentType = icon_map[size][type];

  return <Icon {...other} />;
};
